import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VeeValidateLocaleFr from 'vee-validate/dist/locale/fr'
import VeeValidateLocaleHe from 'vee-validate/dist/locale/he'
import VeeValidateLocaleRu from 'vee-validate/dist/locale/ru'
import VeeValidateLocaleEn from 'vee-validate/dist/locale/en'
import VeeValidateLocaleKo from 'vee-validate/dist/locale/ko'
import VeeValidateLocaleAr from 'vee-validate/dist/locale/ar'
import VeeValidateLocaleTr from 'vee-validate/dist/locale/tr'
import i18n from '@/plugins/i18n'

Vue.use(VeeValidate, {
  locale: i18n.locale,
  dictionary: {
    en: VeeValidateLocaleEn,
    ru: VeeValidateLocaleRu,
    kz: VeeValidateLocaleRu,
    uz: VeeValidateLocaleEn,
    fr: VeeValidateLocaleFr,
    he: VeeValidateLocaleHe,
    ar: VeeValidateLocaleAr,
    ko: VeeValidateLocaleKo,
    tr: VeeValidateLocaleTr
  }
})
